import Vue from 'www/vue_components'
import { piniaGlobal } from 'src/configs'
import initI18next from 'src/utils/initI18next'
import { useContextStore } from 'src/store'
import { vuetify } from 'www/plugins'
import DoctorPageLpuList from 'www/vue_components/common/DoctorPageLpuList/DoctorPageLpuList.vue'
import { initI18n } from 'www/utils'
import getUserLanguage from 'src/utils/getUserLanguage'

const el = document.querySelector('.vue-doctor-page-lpu-list-mount')

const mountDoctorPageLpuList = async () => {
  if (el) {
    await initI18n({ bundle: 'vue_components/common/AppointmentPage' })
    await initI18n({ bundle: 'vue_components/common/Club' })
    await initI18n({ bundle: 'vue_components/common/AppointmentRestrictions' })
    await initI18n({ bundle: 'vue_components/common/AppointmentCalendar' })

    const contextStore = useContextStore(piniaGlobal)

    if (!('flavour' in contextStore.context) || !('currency' in contextStore.context)) {
      contextStore.$patch(state => {
        Object.assign(state.context, {
          flavour: window.MOBILE_VERSION
            ? 'mobile'
            : 'full',
          currency: window.CURRENCY_DATA,
        })
      })
    }

    await initI18next({
      userLanguage: getUserLanguage(piniaGlobal),
    })

    new Vue({
      el,
      name: 'DoctorPageLpuListRoot',
      vuetify,
      pinia: piniaGlobal,
      components: {
        DoctorPageLpuList,
      },
    })
  }
}

mountDoctorPageLpuList()
